import {
  Component,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
  signal,
  ChangeDetectorRef,
} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  FileBlobService, FileManagerBackendApiService1,
  ProjectService,
  TenantService,
  UserService
} from '../../_services/index';

import {
  ClientContact,
  ClientITProfile,
  Company,
  NetworkDescriptionAndDiagram,
  ProjectControlItem,
  SystemInterconnection,
  SystemRolePrivilege,
  User,
} from '../../_models/index';

import {
  Access,
  ClientContactRole,
  CompanyType,
  DataDirection,
  Role,
} from '../../helpers/index';

import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';

import * as XLSX from 'xlsx';
import * as _ from 'lodash';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import html2pdf from "html2pdf.js";
import * as JSZip from 'jszip';
import {PDFDocument} from 'pdf-lib';
import {saveAs} from 'file-saver';
import {forkJoin, Observable} from 'rxjs';
import {map} from 'rxjs/operators';


import {saveAs as importedSaveAs} from 'file-saver';

import {LoginHelper} from '../../helpers';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {NameAndIdentifier} from '../../_models/nameAndIdentifier';
import {NameAndIdentifierTypeList} from '../../_models/nameAndIdentifierType';
import {SystemLocation} from '../../_models/systemLocation';
import {Device} from '../../_models/device';
import {OtherDesignatedContact} from '../../_models/otherDesignatedContact';
import {SystemSecurityPlanApproval} from '../../_models/systemSecurityPlanApproval';
import {SensitivityCategorization} from '../../_models/sensitivityCategorization';
import {ControlOrigination} from '../../_models/controlOrigination';
import {LeveragedAuthorization} from '../../_models/leveragedAuthorization';
import {PortProtocolService} from '../../_models/portProtocolService';
import {StandartAndGuidance} from '../../_models/standartAndGuidance';
import {LawAndRegulation} from '../../_models/lawAndRegulation';
import {RoleSensitivityLevel} from '../../_models/roleSensitivityLevel';
import {Constants} from '../../helpers/constants';
import {TenantPermissions} from '../../_models/tenantPermissions';
import {SelectControlItemComponent} from '../selectControlItem/select-control-item.component';
import {SelectProjectControlItemComponent} from '../selectProjectControlItem/select-project-control-item.component';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {InformationType} from "../../_models/informationType";
import {SeparationOfDuty} from "../../_models/separationOfDuty";
import {SeparationOfDutyRole} from "../../_models/separationOfDutyRole";
import {AuthorizedService} from "../../_models/authorizedService";
import {ExternalSystem} from "../../_models/externalSystem";
import {MatDialogModule} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatRadioChange} from '@angular/material/radio';


import {UploadFrameworkDialogComponent} from '../uploadFrameworkDialog/uploadFrameworkDialog.component';
import {AddCategoryDialogComponent} from '../addCategoryDialog/addCategoryDialog.component';
import {AddControlItemDialogComponent} from '../addControlItemDialog/addControlItemDialog.component';
import {HttpClient} from '@angular/common/http';
import {TrustBuilderFramework} from '../../_models/trustBuilderFramework';
import {TrustReport} from '../../_models/trustReport';
import {TrustBuilderControlCategory} from '../../_models/trustBuilderControlCategory';
import {TrustBuilderControlItem} from '../../_models/trustBuilderControlItem';
import {TrustBuilderPersonnel} from '../../_models/trustBuilderPersonnel';
import {TrustBuilderEvidence} from '../../_models/trustBuilderEvidence';
import {TrustReportService} from '../../_services/trustreport.service';
import {EditTrustReportDialogComponent} from '../editTrustReportDialog/editTrustReportDialog.component';
import {TrainingInviteComponent} from "../trainingInvite/training-invite.component";
import {TrustBuilderInviteComponent} from "../trustBuilderInvite/trustBuilder-invite.component";
import {DocumentSelectComponent} from "../documentSelect";
import {DocumentFolderSelect} from "../documentFolderSelect/documentFolderSelect.component";
import {FileManagerApiService} from "../../external/angular2-filemanager/store/fileManagerApi.service";


@Component({
  standalone: false,
  selector: 'app-trust-builder',
  templateUrl: './trustBuilder.component.html',
  styleUrls: ['./trustBuilder.component.scss'],
  providers: [DialogService, TrustReportService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrustBuilderComponent implements OnInit, OnDestroy {
  settings: any = {};
  api: string;
  isTrustReportUser = false;

  users: User[] = [];
  assignedUsers: User[] = [];
  viewerUsers: User[] = [];
  trustReports: any[] = [];
  trustReport: any = null;
  formGroup: FormGroup;
  activeTab: 'report' | 'forms' | 'external' = 'report';
  uploadedSurveyFile: File | null = null;
  surveyLoaded = false;
  inviteText: string = '';
  policiesAndProcedures: any[];
  assessmentsAndAuthorizations: any[];
  securityPlans: any[];

  survey: any = {
    name: '',
    fileName: '',
    questions: []
  };
  matchSummary = {
    total: 0,
    matched: 0,
    unmatched: 0
  };


  autoControlItems: TrustBuilderControlItem[] = [];
  profile = false;
  frameworksData = [
    {
      name: 'C5',
      imageUrl: '../../assets/icon/rizkly c5.jpg',
      selected: false,
      categories: ['Infrastructure Security', 'Organizational Security', 'Vendor Compliance']
    },
    {
      name: 'NISC',
      imageUrl: '../../assets/icon/rizkly nisc.png',
      selected: false,
      categories: ['Infrastructure Security', 'Organizational Security', 'Internal Security', 'Vendor Compliance']
    },
    {
      name: 'NIST 800-53',
      imageUrl: '../../assets/icon/rizkly nist800-53.jpeg',
      selected: false,
      categories: ['Infrastructure Security', 'Organizational Security', 'Data Privacy', 'Service Continuity', 'Product Security']
    },
    {
      name: 'NIST 800-171',
      imageUrl: '../../assets/icon/rizkly nist800-171.png',
      selected: false,
      categories: ['Infrastructure Security', 'Organizational Security', 'Internal Security', 'Data Privacy']
    },
    {
      name: 'PCI DSS',
      imageUrl: '../../assets/icon/rizkly pci advisor.png',
      selected: false,
      categories: ['Infrastructure Security', 'Organizational Security', 'Data Privacy', 'Vendor Compliance']
    },
    {
      name: 'SOC 2',
      imageUrl: '../../assets/icon/rizkly SOC2 advisor.jpg',
      selected: false,
      categories: ['Infrastructure Security', 'Organizational Security', 'Service Continuity', 'Vendor Compliance', 'Data Privacy']
    },
    {
      name: 'CIS Controls',
      imageUrl: '../../assets/icon/rizkly cis .png',
      selected: false,
      categories: ['Infrastructure Security', 'Organizational Security', 'Internal Security']
    },
    {
      name: 'CMMC',
      imageUrl: '../../assets/icon/rizkly cmmc.jpeg',
      selected: false,
      categories: ['Infrastructure Security', 'Organizational Security', 'Internal Security', 'Vendor Compliance']
    },
    {
      name: 'DORA',
      imageUrl: '../../assets/icon/rizkly dora.png',
      selected: false,
      categories: ['Organizational Security', 'Service Continuity', 'Vendor Compliance', 'Contingency Planning']
    },
    {
      name: 'FedRAMP',
      imageUrl: '../../assets/icon/rizkly fedramp.jpeg',
      selected: false,
      categories: ['Infrastructure Security', 'Organizational Security', 'Data Privacy', 'Vendor Compliance', 'Service Continuity']
    },
    {
      name: 'FedRAMP 2.0',
      imageUrl: '../../assets/icon/rizkly fedramp20x.png',
      selected: false,
      categories: ['Infrastructure Security', 'Organizational Security', 'Data Privacy', 'Vendor Compliance', 'Service Continuity']
    },
    {
      name: 'GDPR',
      imageUrl: '../../assets/icon/rizkly gdpr logo.png',
      selected: false,
      categories: ['Data Privacy', 'Organizational Security', 'Vendor Compliance']
    },
    {
      name: 'HIPAA',
      imageUrl: '../../assets/icon/rizkly hipaa.png',
      selected: false,
      categories: ['Data Privacy', 'Organizational Security', 'Service Continuity']
    },
    {
      name: 'IRAP',
      imageUrl: '../../assets/icon/rizkly irap.jpeg',
      selected: false,
      categories: ['Infrastructure Security', 'Organizational Security', 'Vendor Compliance', 'Service Continuity']
    },
    {
      name: 'ISO 9001',
      imageUrl: '../../assets/icon/rizkly iso9001 advisor.png',
      selected: false,
      categories: ['Organizational Security', 'Product Security', 'Vendor Compliance']
    },
    {
      name: 'ISO 42001',
      imageUrl: '../../assets/icon/rizkly iso42001.jpeg',
      selected: false,
      categories: ['AI Security & Compliance', 'Organizational Security', 'Product Security']
    },
    {
      name: 'NIS2',
      imageUrl: '../../assets/icon/rizkly NIS2.webp',
      selected: false,
      categories: ['Infrastructure Security', 'Organizational Security', 'Internal Security', 'Contingency Planning']
    }
  ];

  controlCategoriesData = [{name: 'Infrastructure Security', selected: false}, {
    name: 'Organizational Security',
    selected: false
  }, {name: 'Internal Security', selected: false}, {
    name: 'AI Security & Compliance',
    selected: false
  }, {name: 'Product Security', selected: false}, {name: 'Data Privacy', selected: false}, {
    name: 'Service Continuity',
    selected: false
  }, {name: 'Contingency Planning', selected: false}, {name: 'Vendor Compliance', selected: false}];

  controlItemDefinitions: { [category: string]: { title: string; description: string }[] } = {};
  tenantName: string = LoginHelper.getTenantName();
  clientLogo: string;
  consultantLogo: string;
  today = new Date();


  constructor(
    public dialog: MatDialog,
    public dialogService: DialogService,
    public alertService: AlertService,
    public router: Router,
    public route: ActivatedRoute,
    public authenticationService: AuthenticationService,
    public _formBuilder: FormBuilder,
    private clientProfileService: ClientProfileService,
    private userService: UserService,
    public projectsService: ProjectService,
    public trustReportService: TrustReportService,
    public fileBlobService: FileBlobService,
    public tenantService: TenantService,
    public fileManagerBackendApiService: FileManagerApiService,
    private cdRef: ChangeDetectorRef,
    private http: HttpClient,
  ) {
    this.api = window.location.origin || Constants.DefaultApiHost;
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.isTrustReportUser = currentUser.role === Role.TrustCenterViewer;
  }

  async ngOnInit(): Promise<void> {
    this.formGroup = this._formBuilder.group({});

    this.userService.getPublicManagers(LoginHelper.getTenantName()).subscribe(managersInfo => {
      this.clientLogo = window.location.origin + '/api/attachments/file?name=' + encodeURIComponent((managersInfo.clientCompany || {}).logoFileName) + '&path=Account/System/' + '&token=' + LoginHelper.getFileToken();
      this.consultantLogo = (managersInfo.consultantCompany || {}).logoFileName ? (window.location.origin + '/api/attachments/file?name=' + encodeURIComponent((managersInfo.consultantCompany || {}).logoFileName) + '&path=Account/System/' + '&token=' + LoginHelper.getFileToken()) : '../assets/img/logo_light1.png';
    });
    this.clientProfileService.getSettings(LoginHelper.getTenantName()).subscribe(s => this.settings = s);

    await this.loadAutoControlItems();

    //console.time("get reports");
    forkJoin([this.userService.getAllShort(),
      this.trustReportService.getAllTrustReports()]).subscribe(res => {
      //console.timeEnd("get reports");
      //console.log('[ngOnInit] Loaded reports:', reports);

      this.users = res[0];
      const reports = res[1];
      if (reports && reports.length > 0) {
        this.trustReports = reports;
        this.trustReport = reports[0];
        this.loadAllFiles();
        this.buildFormFromReport(this.trustReport);
        this.profile = true;
        this.assignedUsers = this.users.filter(u => this.trustReport.assignedUsers.find(i => u.userId === i.userId));
        this.viewerUsers = this.users.filter(u => u.role === Role.TrustCenterViewer);
          console.log("VIEWER USERS:");
        console.log(this.viewerUsers);
        this.cdRef.detectChanges();
      } else {
        console.log('[ngOnInit] No reports found, creating default report');
        const newReport = this.buildDefaultTrustReport();
        console.log('[ngOnInit] New report prepared:', newReport);

        this.trustReportService.createTrustReport(newReport).subscribe(created => {

          this.trustReports = [created];
          this.trustReport = created;
          this.loadAllFiles();
          this.buildFormFromReport(created);
          this.profile = true;
          this.assignedUsers = this.users.filter(u => this.trustReport.assignedUsers.find(i => u.userId === i.userId));
          this.viewerUsers = this.users.filter(u => u.role === Role.TrustCenterViewer);
          this.cdRef.detectChanges();
        });
      }
    });
  }


  private loadAutoControlItems(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http.get<any[]>('assets/trustbuilderdata.json').subscribe({
        next: (items) => {
          console.log('[loadAutoControlItems] Loaded JSON items:', items);

          this.autoControlItems = (items || []).map(item => ({
            category: item?.Category || '',
            title: item?.Title || '',
            description: item?.Description || '',
            response: '' as 'Yes' | 'No' | 'N/A' | 'Custom',
            customResponse: '',
            note: '',
            showNote: false,
            evidences: []
          }));

          console.log('[loadAutoControlItems] Mapped controlItems:', this.autoControlItems);

          this.initFormControls();
          resolve();
        },
        error: (err) => reject(err)
      });
    });
  }


  initFormControls() {
    if (!Array.isArray(this.autoControlItems)) {
      console.warn('[initFormControls] autoControlItems is not an array, initializing empty array');
      this.autoControlItems = [];
    }

    const controlItemControls = this._formBuilder.array(
      this.autoControlItems.map(item => this._formBuilder.group({
        category: [item?.category || ''],
        title: [item?.title || ''],
        description: [item?.description || ''],
        response: [item?.response || '', Validators.required],
        customResponse: [item?.customResponse || ''],
        note: [item?.note || ''],
        showNote: [item?.showNote || false],
        evidences: [item?.evidences || []],
      }))
    );

    if (this.formGroup.contains('autoControlItems')) {
      this.formGroup.setControl('autoControlItems', controlItemControls);
    } else {
      this.formGroup.addControl('autoControlItems', controlItemControls);
    }

    console.log("Form Control init complete, total items:", this.autoControlItems.length);
  }


  private buildFormFromReport(report: TrustReport) {
    console.log('[buildFormFromReport] Building form from report:', report);

    const buildPersonnelArray = (section: string) => {
      const existing = (report.personnel || []).filter(p => p.section === section);
      return this._formBuilder.array(
        (existing.length > 0 ? existing : [{name: '', role: '', section}]).map(p =>
          this._formBuilder.group({
            name: [p.name],
            role: [p.role],
            section: [p.section]
          })
        )
      );
    };

    const buildPersonnelGroup = (section: string, imageUrl?: string) => {
      return this._formBuilder.group({
        people: buildPersonnelArray(section),
        imageUrl: [imageUrl || '']
      });
    };

    this.formGroup = this._formBuilder.group({
      title: [report.title || ''],
      name: [report.name || ''],
      subtitle: [report.subtitle || ''],
      isPublished: [report.isPublished || false],
      disclaimer: [report.disclaimer || ''],
      goose: "goose",
      frameworks: this._formBuilder.array(
        (report.frameworks || []).map(f =>
          this._formBuilder.group({
            name: [f.name],
            imageUrl: [f.imageUrl],
            selected: [f.selected],
            categories: [f.categories || []]
          })
        )
      ),

      controlCategories: this._formBuilder.array(
        (report.categories || []).map(c =>
          this._formBuilder.group({
            name: [c.name],
            selected: [c.selected],
            controlItems: this._formBuilder.array(
              (c.controlItems || []).map(f =>
                this._formBuilder.group({
                  category: [c.name],
                  title: [f.title],
                  description: [f.description],
                  response: [f.response],
                  customResponse: [f.customResponse],
                  note: [f.note],
                  showNote: [f.showNote],
                  evidences: [f.evidences],
                })
              )
            )
          })
        )
      ),

      personnel: this._formBuilder.group({
        companyOwners: buildPersonnelGroup(
          'CompanyOwner',
          report.ownerImageURL || this.clientLogo || ''
        ),
        complianceAdvisors: buildPersonnelGroup(
          'ComplianceAdvisor',
          report.advisorImageURL || this.consultantLogo || ''
        ),
        thirdPartyAssessors: buildPersonnelGroup(
          'ThirdPartyAssessor',
          report.assessorImageURL || ''
        )
      })
    });

    console.log('[buildFormFromReport] Final form value:', this.formGroup.value);
  }

  private buildDefaultTrustReport(name: string = 'New Trust Report'): TrustReport {
    console.log("Building Default Trust Report");
    const frameworks = (this.frameworksData || []).map(fw => ({
      name: fw.name || 'Framework',
      imageUrl: fw.imageUrl || '',
      selected: fw.selected ?? false,
      categories: fw.categories || [],
      trustReportId: 0
    }));

    const categories = (this.controlCategoriesData || []).map(cat => ({
      name: cat.name || 'Category',
      selected: cat.selected ?? false,
      controlItems: (this.autoControlItems?.filter(ci => ci.category === cat.name) || []).map(ci => ({
        category: ci.category,
        title: ci.title || 'Title',
        description: ci.description || '',
        response: ci.response || '',
        customResponse: ci.customResponse || '',
        note: ci.note || '',
        showNote: ci.showNote || false,
        evidences: ci.evidences || [],
      })),
      trustReportId: 0
    }));


    return {
      id: 0,
      name: name || 'Default Report Name',
      title: 'Default Report Title',
      subtitle: '',
      isPublished: false,
      disclaimer: '',
      frameworks: frameworks,
      categories: categories,
      assignedUsers: [],
      ownerImageURL: this.clientLogo,
      advisorImageURL: this.consultantLogo,
      assessorImageURL: 'Assessor Image',
      personnel: [
        {name: 'Owner Name', role: 'Owner', section: 'CompanyOwner', trustReportId: 0},
        {name: 'Advisor Name', role: 'Advisor', section: 'ComplianceAdvisor', trustReportId: 0},
        {name: 'Assessor Name', role: 'Assessor', section: 'ThirdPartyAssessor', trustReportId: 0}
      ]
    };
  }


  logTitle() {
    /*console.log('Current title value:', this.formGroup.get('title')?.value);
    console.log('Current goose value:', this.formGroup.get('goose')?.value);
    console.log('Current trust report:', this.trustReport);
    console.log('Current form thing:', this.formGroup.value);*/
  }

  getFrameworks() {
    const fw = (this.formGroup.get('frameworks') as FormArray).controls;
    return fw;
  }

  getControlCategories() {
    const cc = (this.formGroup.get('controlCategories') as FormArray).controls;
    return cc;
  }

  getControlCategoriesFA(): FormArray {
    return this.formGroup.get('controlCategories') as FormArray;
  }

  getControlItems(categoryIndex: number): FormArray {
    return (this.getControlCategoriesFA().at(categoryIndex).get('controlItems') as FormArray);
  }

  getControlItemsForCategory(category: string) {
    return this.autoControlItems.filter(item => item.category === category);
  }

  getControlItemsControls(category: FormGroup): FormGroup[] {
    return (category.get('controlItems') as FormArray).controls as FormGroup[];
  }

  getControlItemIndex(item: TrustBuilderControlItem): number {
    return this.autoControlItems.indexOf(item);
  }


  ngOnDestroy(): void {

  }

  toggleFrameworkSelection(index: number) {
    const frameworkCtrl = this.getFrameworks()[index];
    const wasSelected = frameworkCtrl.value.selected;
    const newSelected = !wasSelected;

    frameworkCtrl.patchValue({selected: newSelected});

    if (!newSelected) {
      this.removeCategoriesFromUnselectedFramework(frameworkCtrl.value);
    } else {
      frameworkCtrl.value.categories.forEach((catName: string) => {
        const categoryCtrl = this.getControlCategories().find(catCtrl =>
          catCtrl.value.name === catName
        );
        if (categoryCtrl) {
          categoryCtrl.patchValue({selected: true});
        }
      });
    }
  }

  removeCategoriesFromUnselectedFramework(unselectedFramework: any) {
    const stillSelectedFrameworks = this.getFrameworks()
      .map(f => f.value)
      .filter(f => f.selected);

    unselectedFramework.categories.forEach((catName: string) => {
      const stillNeeded = stillSelectedFrameworks.some(fw =>
        fw.categories.includes(catName)
      );

      if (!stillNeeded) {
        const categoryCtrl = this.getControlCategories().find(catCtrl =>
          catCtrl.value.name === catName
        );
        if (categoryCtrl) {
          categoryCtrl.patchValue({selected: false});
        }
      }
    });
  }


  toggleControlCategorySelection(index: number) {
    const category = this.getControlCategories()[index];
    category.patchValue({selected: !category.value.selected});

  }

  getSelectedFrameworks() {
    return this.getFrameworks().filter(f => f.value.selected);
  }

  getSelectedControlCategories() {
    const categories = this.getControlCategories().filter(c => c.value.selected);

    //console.log('[getSelectedControlCategories] returning:', categories.map(c => c.value));

    //console.log('[getSelectedControlCategories] full control categories:', this.getControlCategories().map(c => c.value));

    return categories;
  }


  async onTrustReportChanged(newValue: TrustReport): Promise<void> {
    if (!this.trustReport || this.trustReport.id == newValue.id) {
      console.log("It's the same TrustReport");
      return;
    }
    console.log("==== Begin Change Trust Report ====");
    const oldReport = this.trustReport;
    console.log("Old report:", oldReport);
    console.log("New report:", newValue);

    await this.onDone();

    let refreshedReport: TrustReport | null = null;
    try {
      refreshedReport = await this.trustReportService.getTrustReportsById(newValue.id).toPromise();
    } catch (err) {
      console.error("Failed to fetch report", err);
      this.alertService.warn("Error: Failed to fetch report.");
      return;
    }
    console.log("Got refreshed report ", refreshedReport);

    if (refreshedReport) {
      const idx = this.trustReports.findIndex(r => r.id === refreshedReport.id);
      if (idx > -1) {
        this.trustReports[idx] = refreshedReport;
      }
    }

    this.trustReport = refreshedReport;
    this.loadAllFiles();
    if (this.trustReport) {
      this.buildFormFromReport(this.trustReport);
      this.profile = true;
    } else {
      this.profile = false;
    }

    this.cdRef.detectChanges();
    console.log("done changing report!");
  }


  async createTrustReport(): Promise<void> {

    await this.onDone();

    const newReport = this.buildDefaultTrustReport('New Trust Report');
    this.trustReportService.createTrustReport(newReport).subscribe({
      next: (created) => {
        console.log('Created report:', created);
        this.trustReports.push(created);
        this.trustReport = created;
        this.loadAllFiles();
        this.buildFormFromReport(created);

        this.cdRef.detectChanges();
      },
      error: (err) => {
        console.error('Error creating trust report', err);
        this.alertService.warn("Error: Could not create new trust report, ", err);
      }
    });
  }

  async duplicateTrustReport(): Promise<void> {
    if (!this.trustReport.id) return;
    //console.log("Begin duplicate of trust report ", this.trustReport);
    await this.onDone();


    const formValue = this.formGroup.value;

    const personnel = [
      ...(formValue.personnel.companyOwners.people || []),
      ...(formValue.personnel.complianceAdvisors.people || []),
      ...(formValue.personnel.thirdPartyAssessors.people || [])
    ].filter(p => p.name && p.role);

    const duplicated: TrustReport = {
      name: formValue.name + " (Copy)",
      title: formValue.title,
      subtitle: formValue.subtitle,
      isPublished: formValue.isPublished,
      disclaimer: formValue.disclaimer,
      ownerImageURL: formValue.personnel.companyOwners.imageUrl || '',
      advisorImageURL: formValue.personnel.complianceAdvisors.imageUrl || '',
      assessorImageURL: formValue.personnel.thirdPartyAssessors.imageUrl || '',

      frameworks: (formValue.frameworks || []).map(f => ({
        name: f.name,
        imageUrl: f.imageUrl,
        selected: f.selected,
        categories: f.categories
      })),

      categories: (formValue.controlCategories || []).map(c => ({
        name: c.name,
        selected: c.selected,
        controlItems: (c.controlItems || []).map(ci => ({
          category: ci.category,
          title: ci.title,
          description: ci.description,
          response: ci.response,
          customResponse: ci.customResponse,
          note: ci.note,
          showNote: ci.showNote,
          evidences: ci.evidences,
        }))
      })),

      personnel: personnel.map(p => ({
        name: p.name,
        role: p.role,
        section: p.section
      }))
    };
    //console.log("Duplicating report, duped report ", duplicated);

    this.trustReportService.createTrustReport(duplicated).subscribe({
      next: (copy) => {
        console.log('Duplicated report:', copy);
        this.trustReports.push(copy);
        this.trustReport = copy;
        this.loadAllFiles();
        this.buildFormFromReport(copy);
        this.cdRef.detectChanges();
      },
      error: (err) => {
        console.error('Error duplicating trust report', err);
        this.alertService.warn("Error: Could not duplicate trust report.");
      }
    });
  }


  removeTrustReport(): void {
    if (!this.trustReport) {
      console.log("No report!")
      return;
    }
    const report = this.trustReport;
    this.trustReportService.deleteTrustReport(report.id).subscribe({
      next: () => {
        //console.log('Deleted report:', report);
        this.trustReports = this.trustReports.filter(r => r.id !== report.id);

        if (this.trustReport?.id === report.id) {
          if (this.trustReports.length > 0) {
            this.trustReport = this.trustReports[0];
            this.loadAllFiles();
            this.buildFormFromReport(this.trustReport);
          } else {
            const newReport = this.buildDefaultTrustReport();
            this.trustReportService.createTrustReport(newReport).subscribe(created => {
              this.trustReports = [created];
              this.trustReport = created;
              this.loadAllFiles();
              this.buildFormFromReport(created);
              this.cdRef.detectChanges();
            });
            return;
          }
        }
        this.cdRef.detectChanges();
      },
      error: (err) => {
        console.error('Error deleting trust report', err);
        this.alertService.warn("Error: Could not delete trust report, ", err);
      }
    });
  }


  editTrustReport(report: TrustReport): void {
    const dialogRef = this.dialog.open(EditTrustReportDialogComponent, {
      width: '400px',
      data: {name: this.formGroup.get('name')?.value}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.formGroup.get('name')?.setValue(result);
        this.trustReport.name = result;
        const idx = this.trustReports.findIndex(r => r.id === report.id);
        if (idx !== -1) {
          this.trustReports[idx] = {...report};
        }

        this.trustReports = [...this.trustReports];
        //console.log('Updated report name:', result);
      }

    });
  }


  async onDone(): Promise<void> {
    if (!this.formGroup.valid) {
      //console.log(this.formGroup.value);
      console.warn("Form is invalid, not saving.");
      this.alertService.warn("Error saving: Invalid report.");
      return;
    }
    console.time("buildReport");
    const formValue = this.formGroup.value;

    const personnel = [
      ...(formValue.personnel.companyOwners.people || []),
      ...(formValue.personnel.complianceAdvisors.people || []),
      ...(formValue.personnel.thirdPartyAssessors.people || [])
    ].filter(p => p.name && p.role);

    const report: TrustReport = {
      ...this.trustReport,
      name: formValue.name,
      title: formValue.title,
      subtitle: formValue.subtitle,
      isPublished: formValue.isPublished,
      disclaimer: formValue.disclaimer,
      ownerImageURL: formValue.personnel.companyOwners.imageUrl || '',
      advisorImageURL: formValue.personnel.complianceAdvisors.imageUrl || '',
      assessorImageURL: formValue.personnel.thirdPartyAssessors.imageUrl || '',
      assignedUsers: this.assignedUsers,

      frameworks: (formValue.frameworks || []).map(f => ({
        name: f.name,
        imageUrl: f.imageUrl,
        selected: f.selected,
        categories: f.categories
      })),

      categories: (formValue.controlCategories || []).map(c => ({
        name: c.name,
        selected: c.selected,
        controlItems: (c.controlItems || []).map(ci => ({
          category: ci.category,
          title: ci.title,
          description: ci.description,
          response: ci.response,
          customResponse: ci.customResponse,
          note: ci.note,
          showNote: ci.showNote,
          evidences: ci.evidences,
        }))
      })),

      personnel: personnel.map(p => ({
        name: p.name,
        role: p.role,
        section: p.section
      }))
    };
    //this.trustReport = report;
    //this.buildFormFromReport(report); why did i have this here???
    this.cdRef.detectChanges();

    console.timeEnd("buildReport");
    //console.log("Saving TrustReport:", report);

    console.time("saveReport");
    return new Promise<void>((resolve) => {
      this.trustReportService.updateTrustReport(report).subscribe({
        next: (updated) => {
          console.log("TrustReport saved:", updated);
          this.alertService.success(`Saved report "${updated.name}"`);
          console.timeEnd("saveReport");
          resolve();
        },
        error: (err) => {
          console.error("Error saving TrustReport:", err);
          this.alertService.error("Failed to save report.");
          console.log("Error with TrustReport: ", report);
          console.timeEnd("saveReport");
          resolve();
        }
      });
    });
  }


  openUploadFrameworkDialog() {
    const dialogRef = this.dialog.open(UploadFrameworkDialogComponent, {
      width: '400px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const frameworks = this.formGroup.get('frameworks') as FormArray;

        frameworks.push(this._formBuilder.group({
          name: [result.name],
          imageUrl: [result.src],
          selected: [true],
          categories: this._formBuilder.array([])
        }));

        //console.log('[openUploadFrameworkDialog] Frameworks after add:', frameworks.value);
        this.cdRef.detectChanges();

      }
    });
  }

  openAddCategoryDialog() {
    const dialogRef = this.dialog.open(AddCategoryDialogComponent, {
      width: '300px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const cats = this.formGroup.get('controlCategories') as FormArray;

        cats.push(this._formBuilder.group({
          name: [result],
          selected: [true],
          controlItems: this._formBuilder.array([])
        }));

        //console.log('[openAddCategoryDialog] ControlCategories after add:', cats.value);
        this.cdRef.detectChanges();
      }
    });
  }

  openAddControlItemDialog(categoryName: string) {
    const dialogRef = this.dialog.open(AddControlItemDialogComponent, {
      width: '400px',
      data: {category: categoryName}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const categories = this.formGroup.get('controlCategories') as FormArray;
        const categoryIndex = categories.controls.findIndex(c => c.get('name')?.value === categoryName);

        if (categoryIndex !== -1) {
          const controlItems = categories.at(categoryIndex).get('controlItems') as FormArray;

          controlItems.push(this._formBuilder.group({
            category: [categoryName],
            title: [result.title],
            description: [result.description],
            response: [''],
            customResponse: [''],
            note: '',
            showNote: false,
            evidences: [[]],
          }));

          //console.log(`[openAddControlItemDialog] Control items for ${categoryName}:`, controlItems.value);
          this.cdRef.detectChanges();
        } else {
          console.warn(`[openAddControlItemDialog] Category not found: ${categoryName}`);
        }
      }
    });
  }

  getCompanyOwners() {
    return (this.formGroup.get('personnel.companyOwners') as FormArray).controls;
  }

  getComplianceAdvisors() {
    return (this.formGroup.get('personnel.complianceAdvisors') as FormArray).controls;
  }

  getThirdPartyAssessors() {
    return (this.formGroup.get('personnel.thirdPartyAssessors') as FormArray).controls;
  }

  addCompanyOwner() {
    const owners = this.formGroup.get('personnel.companyOwners') as FormArray;
    owners.push(this._formBuilder.group({
      name: [''],
      role: [''],
      section: ['CompanyOwner']
    }));
    //console.log('[addCompanyOwner] Added new owner:', owners.value);
  }

  addPersonnel(section: 'CompanyOwner' | 'ComplianceAdvisor' | 'ThirdPartyAssessor') {
    const personnelGroup = this.formGroup.get('personnel') as FormGroup;

    const sectionGroup = personnelGroup.get(
      section === 'CompanyOwner'
        ? 'companyOwners'
        : section === 'ComplianceAdvisor'
          ? 'complianceAdvisors'
          : 'thirdPartyAssessors'
    ) as FormGroup;

    const peopleArray = sectionGroup.get('people') as FormArray;

    peopleArray.push(
      this._formBuilder.group({
        name: [''],
        role: [''],
        section: [section]
      })
    );
  }

  hasSelections(): boolean {
    const frameworksSelected = this.formGroup.get('frameworks')?.value.some((f: any) => f.selected);
    const categoriesSelected = this.formGroup.get('controlCategories')?.value.some((c: any) => c.selected);
    return !!(frameworksSelected || categoriesSelected);
  }

  hasResponses(category: FormGroup): boolean {
    const controlItems = category.get('controlItems') as FormArray;
    return controlItems.controls.some(ci => ci.get('response')?.value || ci.get('customResponse')?.value);
  }

  onUploadImage(controlPath: string, event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      return;
    }

    const file = input.files[0];
    const reader = new FileReader();


    reader.onload = () => {
      const control = this.formGroup.get(controlPath);
      if (control) {
        control.patchValue(reader.result as string); // base64 image
        this.cdRef.detectChanges();
      } else {
        console.warn(`[onUploadImage] Control not found for path: ${controlPath}`);
      }
    };

    reader.readAsDataURL(file); // convert file to base64 data URL
  }


  async saveAsPDF() {
    const reportElement = document.querySelector('.report-view') as HTMLElement;
    if (!reportElement) return;


    const options = {
      margin: 10,
      filename: `${this.formGroup.value.title || 'trust-report'}.pdf`,
      image: {type: 'jpeg' as "jpeg" | "png" | "webp", quality: 1.0},
      html2canvas: {scale: 1.5, useCORS: true, scrollY: 0, backgroundColor: '#ffffff'},
      jsPDF: {unit: 'mm', format: 'a4', orientation: 'portrait' as "portrait" | "landscape"},
      // TODO :: migration
      //pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
    };

    const pdfArrayBuffer = await html2pdf()
      .set(options)
      .from(reportElement)
      .output('arraybuffer');

    const pdfDoc = await PDFDocument.load(pdfArrayBuffer);

    const categories = this.formGroup.value.categories || [];
    for (const cat of categories) {
      const controlItems = cat.controlItems || [];
      for (const ci of controlItems) {
        const evidences = ci.evidences || [];
        for (const ev of evidences) {
          if (!ev.base64Data) continue;
          try {
            const fileBytes = Uint8Array.from(atob(ev.base64Data), c => c.charCodeAt(0));
            const mimeType = ev.mimeType || 'application/octet-stream';
            const filename = ev.name || 'evidence.bin';

            pdfDoc.attach(fileBytes, filename, {
              mimeType,
              description: `Evidence for control item: ${ci.title}`
            });
          } catch (err) {
            console.error('Failed to attach evidence:', ev.name, err);
          }
        }
      }
    }

    const finalBytes = await pdfDoc.save();
    const blob = new Blob([new Uint8Array(finalBytes)], {type: 'application/pdf'});

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${this.formGroup.value.title || 'trust-report'}.pdf`;
    link.click();

  }


  async saveAsHTMLZip() {
    const zip = new JSZip();
    const imagesFolder = zip.folder("images");

    const reportElement = document.querySelector('.report-view') as HTMLElement;
    const reportHTML = reportElement.outerHTML;

    const imgRegex = /<img[^>]+src="([^">]+)"/g;
    let match;
    let imgIndex = 0;
    let finalHTML = reportHTML;

    while ((match = imgRegex.exec(reportHTML)) !== null) {
      let originalSrc = match[1]
        .replace(/&amp;/g, "&");
      try {
        originalSrc = decodeURIComponent(originalSrc);
      } catch {
        // ignore if it's not URI-encoded
      }

      let newFileName = `images/img${imgIndex}.png`;

      //console.log(`Processing image ${imgIndex}: ${originalSrc}`);

      try {
        let blob: Blob | null = null;

        if (originalSrc.startsWith("http") || originalSrc.startsWith("https")) {
          const response = await fetch(originalSrc);
          blob = await response.blob();
        } else if (originalSrc.startsWith("data:image")) {
          const base64Data = originalSrc.split(",")[1];
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          blob = new Blob([byteArray], {type: "image/png"});
        } else if (originalSrc.startsWith("blob:")) {
          const response = await fetch(originalSrc);
          blob = await response.blob();
        } else {
          try {
            const response = await fetch(originalSrc);
            blob = await response.blob();
          } catch {
            console.warn(`Could not process image: ${originalSrc}`);
          }
        }

        if (blob) {
          const arrayBuffer = await blob.arrayBuffer();
          imagesFolder.file(`img${imgIndex}.png`, arrayBuffer);
          //console.log(`Saved as: ${newFileName}`);
          finalHTML = finalHTML.replace(originalSrc, newFileName);
        } else {
          console.warn(`Could not process image: ${originalSrc}`);
        }
      } catch (error) {
        console.error(`Failed to fetch image ${imgIndex}: ${originalSrc}`, error);
      }

      imgIndex++;
    }

    let styles = '';
    for (let i = 0; i < document.styleSheets.length; i++) {
      const sheet = document.styleSheets[i] as CSSStyleSheet;
      try {
        const rules = sheet.cssRules;
        if (!rules) continue;
        for (let j = 0; j < rules.length; j++) {
          styles += rules[j].cssText + '\n';
        }
      } catch (err) {
        console.warn('Could not read stylesheet', (sheet as any).href, err);
      }
    }

    const fullHTML = `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8" />
        <title>${this.formGroup?.value?.title || 'trust-report'}</title>
        <style>
          ${styles}
        </style>
      </head>
      <body>
        ${finalHTML}
      </body>
    </html>
  `;

    zip.file("report.html", fullHTML);

    const content = await zip.generateAsync({type: "blob"});
    saveAs(content, `${this.formGroup?.value?.title || 'trust-report'}.zip`);
  }

  onResponseChange(categoryIndex: number, itemIndex: number, event: MatRadioChange | any) {
    const itemGroup = this.getControlItems(categoryIndex).at(itemIndex) as FormGroup;
    /*console.log('[onResponseChange] event', event);
    console.log('[onResponseChange] response control value', itemGroup.get('response')?.value);
    console.log('[onResponseChange] item form value', itemGroup.value);*/
  }

  onCsvUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];
    const reader = new FileReader();


    reader.onload = () => {
      try {
        const text = reader.result as string;
        this.parseCsvAndAddControls(text);
      } catch (err) {
        console.error(err);
        this.alertService.error('Error: Failed to parse CSV file');
      }
    };

    reader.onerror = () => {
      this.alertService.error('Error: Could not read the CSV file');
    };

    reader.readAsText(file);
  }

  private parseCsvAndAddControls(csvText: string): void {
    // Split into rows, trim, skip empties
    const rows = csvText.split(/\r?\n/).map(r => r.trim()).filter(r => !!r);

    if (rows.length === 0) {
      this.alertService.error('Error: CSV file is empty');
      return;
    }

    // Skip header row
    const dataRows = rows.slice(1);

    const categories = this.formGroup.get('controlCategories') as FormArray;
    let importedCount = 0;

    const parseCsvLine = (line: string): string[] => {
      const result: string[] = [];
      let current = '';
      let inQuotes = false;

      for (let i = 0; i < line.length; i++) {
        const char = line[i];

        if (char === '"' && (i === 0 || line[i - 1] !== '\\')) {
          inQuotes = !inQuotes;
        } else if (char === ',' && !inQuotes) {
          result.push(current.trim());
          current = '';
        } else {
          current += char;
        }
      }

      result.push(current.trim());
      return result.filter(c => c !== ''); // remove empty columns
    };

    for (const [rowIdx, row] of dataRows.entries()) {
      const cols = parseCsvLine(row);

      if (cols.length < 3) {
        continue;
      }

      // handle both 3-column and 4-column cases
      const hasFramework = cols.length >= 4;
      const categoryName = hasFramework ? cols[1] : cols[0];
      const title = hasFramework ? cols[2] : cols[1];
      const description = hasFramework ? cols[3] : cols[2];

      if (!categoryName || !title) {
        this.alertService.error(`Error: Row ${rowIdx + 2} missing required category or item name`);
        continue;
      }

      // look for category
      let categoryIndex = categories.controls.findIndex(
        c => c.get('name')?.value === categoryName
      );

      // if not found, create new category
      if (categoryIndex === -1) {
        const newCategory = this._formBuilder.group({
          name: [categoryName],
          controlItems: this._formBuilder.array([]),
          selected: [true]
        });
        categories.push(newCategory);
        categoryIndex = categories.length - 1;
      }

      const controlItems = categories.at(categoryIndex).get('controlItems') as FormArray;

      controlItems.push(this._formBuilder.group({
        category: [categoryName],
        title: [title],
        description: [description],
        response: [''],
        customResponse: [''],
        note: [''],
        showNote: [false],
        evidences: [[]]
      }));

      importedCount++;
    }

    if (importedCount > 0) {
      this.alertService.success(`${importedCount} control item(s) imported successfully`);
    }

    this.cdRef.detectChanges();
  }


  deleteCategory(catIdx: number): void {
    this.getControlCategoriesFA().removeAt(catIdx);
    this.cdRef.detectChanges();
  }

  deleteControlItem(catIdx: number, itemIdx: number): void {
    this.getControlItems(catIdx).removeAt(itemIdx);
    this.cdRef.detectChanges();
  }

  onAddEvidenceFile(event: any, catIdx: number, itemIdx: number) {
    const files = event.target.files;
    if (files.length > 0) {
      const file = files[0];

      const allowedTypes = ['image/png', 'image/jpg', 'application/pdf'];
      if (!allowedTypes.includes(file.type)) {
        this.alertService.warn('Only PNG and PDF files are allowed for upload.');
        event.target.value = '';
        return;
      }


      const reader = new FileReader();

      reader.onload = () => {
        const base64String = (reader.result as string).split(',')[1]; // remove data:mime;base64, prefix

        const newEvidence: TrustBuilderEvidence = {
          name: file.name,
          date: new Date(),
          trustBuilderControlItemId: undefined,
          base64Data: base64String,
          mimeType: file.type
        };

        const controlItem = this.getControlItems(catIdx).at(itemIdx) as FormGroup;
        const evidences = controlItem.get('evidences')?.value || [];
        evidences.push(newEvidence);
        controlItem.get('evidences')?.setValue(evidences);
        this.cdRef.detectChanges();
      };

      this.cdRef.detectChanges();
      reader.readAsDataURL(file);
    }

    this.cdRef.detectChanges();
  }


  onDeleteEvidence(catIdx: number, itemIdx: number, evIdx: number) {
    const controlItem = this.getControlItems(catIdx).at(itemIdx) as FormGroup;
    const evidences = controlItem.get('evidences')?.value || [];
    evidences.splice(evIdx, 1);
    controlItem.get('evidences')?.setValue(evidences);
    this.cdRef.detectChanges();
  }

  downloadEvidence(evidence: TrustBuilderEvidence) {
    const link = document.createElement('a');
    const blob = this.base64ToBlob(evidence.base64Data!, evidence.mimeType!);
    const url = URL.createObjectURL(blob);

    link.href = url;
    link.download = evidence.name;
    link.click();

    URL.revokeObjectURL(url);
  }

  private base64ToBlob(base64: string, mime: string): Blob {
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], {type: mime});
  }

  onSurveyUpload(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      return;
    }

    const file = input.files[0];

    this.uploadedSurveyFile = file;

    console.log('Survey uploaded:', file.name, file.type);

    this.surveyParse(file);
  }

  private getAllControlItems(): any[] {
    const result: any[] = [];

    const categoriesFA = this.getControlCategoriesFA();
    console.log("categories, ", categoriesFA.value);
    if (!categoriesFA) return result;

    categoriesFA.controls.forEach((categoryFG: FormGroup) => {
      console.log("categoryFG", categoryFG.value);
      const categoryName = categoryFG.value.name;
      const controlItemsFA = categoryFG.get('controlItems') as FormArray;

      if (!controlItemsFA) return;

      controlItemsFA.controls.forEach((ciFG: FormGroup) => {
        result.push({
          category: categoryName,
          title: ciFG.get('title')?.value,
          description: ciFG.get('description')?.value,
          formGroup: ciFG
        });
      });
    });
    console.log("simplified CIs: ", result);
    return result;
  }

  private async surveyParse(file: File) {
    let parsedQuestions: string[] = [];

    if (file.name.endsWith('.xlsx')) {
      parsedQuestions = await this.parseXlsxSurvey(file);
    } else if (file.name.endsWith('.docx')) {
      parsedQuestions = this.parseDocxSurveyPlaceholder(file);
    } else {
      this.alertService.warn('Unsupported file type');
      return;
    }

    const controlItems = this.getAllControlItems();

    console.log('Control items available for matching:', controlItems.length);

    this.surveyLoaded = true;
    this.survey.fileName = file.name;
    this.survey.name = file.name.replace(/\.(csv|xlsx|docx)$/i, '');

    this.survey.questions = parsedQuestions.map(q => {
      const match = this.findBestMatch(q, controlItems);

      if (match) {
        const fg = match.formGroup as FormGroup;
        console.log("match with formgroup ", fg.value);
        let autoResponse = '';
        if (fg.value.response) {
          autoResponse = fg.value.response;
        }
        if (fg.value.response == "Custom") {
          autoResponse = fg.value.customResponse;
        }

        console.log("set autoresponse to ", autoResponse);
        console.log("custom mresponse", fg.value.customResponse);
        console.log("response", fg.value.response);
        if (!fg.value.response && autoResponse) {
          fg.value.response = autoResponse;
        }
        console.log("Found match", match);
        return {
          text: q,
          matched: true,
          matchedItem: `${match.category} - ${match.title}: ${match.description}`,
          confidence: match.confidence,
          autoFilledResponse: autoResponse,
          controlItemFG: fg
        };
      }

      return {
        text: q,
        matched: false
      };

    });

    this.matchSummary.total = this.survey.questions.length;
    this.matchSummary.matched = this.survey.questions.filter(q => q.matched).length;
    this.matchSummary.unmatched =
      this.matchSummary.total - this.matchSummary.matched;

    this.cdRef.detectChanges();
  }

  private async parseXlsxSurvey(file: File): Promise<string[]> {
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data, {type: 'array'});

    const sheetName = workbook.SheetNames[0];
    const sheet = workbook.Sheets[sheetName];

    const rows: any[][] = XLSX.utils.sheet_to_json(sheet, {
      header: 1,
      raw: true
    });

    console.group('[XLSX Survey Parse]');
    console.log('Sheet name:', sheetName);
    console.log('Total rows:', rows.length);

    console.group('First 10 rows (raw)');
    rows.slice(0, 10).forEach((r, i) => {
      console.log(`Row ${i + 1}:`, r);
    });
    console.groupEnd();

    if (!rows || rows.length === 0) {
      console.warn('No rows found');
      console.groupEnd();
      return [];
    }

    const questions: string[] = [];

    for (let i = 1; i < rows.length; i++) {
      const row = rows[i];

      //console.group(`Row ${i + 1}`);

      if (!row) {
        console.warn('Skipped: row is undefined/null');
        //console.groupEnd();
        continue;
      }

      const primaryNumberCell = row[3];  // column C
      const fallbackNumberCell = row[0]; // column A
      const questionCell = row[4];       // column D

      console.log('Primary number cell (C):', primaryNumberCell);
      console.log('Fallback number cell (A):', fallbackNumberCell);
      console.log('Question cell (D):', questionCell);

      const primaryNum = Number(primaryNumberCell);
      const fallbackNum = Number(fallbackNumberCell);

      const hasValidNumber =
        (!isNaN(primaryNum) && primaryNumberCell !== null && primaryNumberCell !== '' && primaryNum > 0) ||
        (!isNaN(fallbackNum) && fallbackNumberCell !== null && fallbackNumberCell !== '' && fallbackNum > 0);

      if (!hasValidNumber) {
        console.warn('No valid numeric identifier found in column C or A');
        console.groupEnd();
        continue;
      } else {
        console.log("nums in col C and A are: ", primaryNum, fallbackNum)
      }

      if (typeof questionCell !== 'string') {
        console.warn('Skipped: question cell is not a string');
        console.groupEnd();
        continue;
      }

      const text = questionCell.trim();

      if (!text) {
        console.warn('Skipped: question text is empty');
        console.groupEnd();
        continue;
      }

      console.log('Accepted question:', text);
      questions.push(text);

      console.groupEnd();
    }

    console.log(`Parsed ${questions.length} questions`);
    console.groupEnd();

    return questions;
  }


  private parseDocxSurveyPlaceholder(file: File): string[] {
    this.alertService.warn(
      'DOCX parsing not implemented yet. Using placeholder questions.'
    );

    return [
      'Does your organization maintain formal information security policies?',
      'How is access to sensitive systems reviewed?',
      'Describe your incident response process.'
    ];
  }

  private stopWords = new Set([
    'the', 'is', 'are', 'and', 'or', 'of', 'to', 'in', 'for', 'with',
    'a', 'an', 'your', 'you', 'do', 'does', 'describe',
    'process', 'procedures', 'policy', 'ensure'
  ]);

  private synonymMap = new Map<string, string[]>([
    ['llm', ['ai', 'model', 'language_model']],
    ['ai', ['model', 'algorithm']],
    ['pii', ['personal', 'identifiable', 'personal_data']],
    ['gdpr', ['privacy', 'data_protection']],
    ['hipaa', ['privacy', 'health']],
    ['sso', ['authentication', 'identity']],
    ['auth', ['authentication', 'authorization']]
  ]);

  private criticalConcepts = [
    {name: 'ai_ml', terms: new Set(['ai', 'llm', 'model']), penalty: 0.60},
    {name: 'encryption', terms: new Set(['encrypt', 'encryption', 'cipher', 'cryptographic']), penalty: 0.25},
    {name: 'access_control', terms: new Set(['access', 'authentication', 'authorization', 'identity']), penalty: 0.25},
    {name: 'incident_response', terms: new Set(['incident', 'breach', 'response', 'containment']), penalty: 0.30},
    {name: 'vendor_risk', terms: new Set(['vendor', 'third', 'supplier', 'outsourced']), penalty: 0.30},
    {name: 'audit_logging', terms: new Set(['audit', 'log', 'logging', 'traceability']), penalty: 0.20},
    {name: 'backup_recovery', terms: new Set(['backup', 'recovery', 'restore', 'disaster']), penalty: 0.25},
    {name: 'privacy', terms: new Set(['privacy', 'gdpr', 'hipaa', 'pii']), penalty: 0.30},
    {name: 'bias_fairness', terms: new Set(['bias', 'fairness', 'discrimination']), penalty: 0.25},
    {name: 'human_oversight', terms: new Set(['human', 'review', 'approval']), penalty: 0.20}
  ];

  private tokenize(text: string): string[] {
    const base = text
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, ' ')
      .split(/\s+/)
      .filter(t =>
        (t.length > 2 || t === 'ai' || t === 'ml') &&
        !this.stopWords.has(t)
      );

    const expanded: string[] = [];
    for (const t of base) {
      expanded.push(t);
      const syns = this.synonymMap.get(t);
      if (syns) expanded.push(...syns);
    }

    return [
      ...expanded,
      ...this.ngrams(expanded, 2),
      ...this.ngrams(expanded, 3)
    ];
  }

  private ngrams(tokens: string[], n: number): string[] {
    const out: string[] = [];
    for (let i = 0; i <= tokens.length - n; i++) {
      out.push(tokens.slice(i, i + n).join('_'));
    }
    return out;
  }

  private buildTfIdfVector(
    tokens: string[],
    docFreq: Map<string, number>,
    totalDocs: number
  ): Map<string, number> {
    const tf = new Map<string, number>();
    tokens.forEach(t => tf.set(t, (tf.get(t) || 0) + 1));

    const vec = new Map<string, number>();
    let norm = 0;

    tf.forEach((count, term) => {
      const df = docFreq.get(term) || 0;
      const idf = Math.log(1 + totalDocs / (1 + df));
      const val = count * idf;
      vec.set(term, val);
      norm += val * val;
    });

    norm = Math.sqrt(norm) || 1;
    vec.forEach((v, k) => vec.set(k, v / norm));
    return vec;
  }

  private cosineSimilarity(a: Map<string, number>, b: Map<string, number>): number {
    let dot = 0;
    a.forEach((v, k) => {
      if (b.has(k)) dot += v * b.get(k)!;
    });
    return dot;
  }

  private complianceBoost(overlapTokens: string[]): number {
    const boostTerms = new Set([
      'access', 'encryption', 'incident', 'risk', 'vendor',
      'audit', 'logging', 'authentication', 'authorization',
      'backup', 'recovery', 'monitoring', 'classification', 'ai'
    ]);

    let hits = 0;
    overlapTokens.forEach(t => {
      if (boostTerms.has(t)) hits++;
    });

    return Math.min(hits * 0.05, 0.25);
  }

  private missingConceptPenalty(
    qTokens: string[],
    itemTokens: string[]
  ): { penalty: number; missing: string[] } {
    let penalty = 0;
    const missing: string[] = [];

    for (const c of this.criticalConcepts) {
      const qHits = qTokens.filter(t => c.terms.has(t)).length;
      if (qHits === 0) continue;

      const itemHas = itemTokens.some(t => c.terms.has(t));
      if (!itemHas) {
        penalty += c.penalty * Math.min(1, qHits / 3);
        missing.push(c.name);
      }
    }

    return {penalty: Math.min(penalty, 0.75), missing};
  }

  private findBestMatch(question: string, controlItems: any[]) {
    const docFreq = new Map<string, number>();
    controlItems.forEach(i => {
      new Set(this.tokenize(`${i.title} ${i.description}`))
        .forEach(t => docFreq.set(t, (docFreq.get(t) || 0) + 1));
    });

    const totalDocs = controlItems.length;
    const qTokens = this.tokenize(question);
    const qVec = this.buildTfIdfVector(qTokens, docFreq, totalDocs);

    let best: any = null;
    let bestScore = 0;

    for (const item of controlItems) {
      const titleTokens = this.tokenize(item.title);
      const descTokens = this.tokenize(item.description);

      const titleVec = this.buildTfIdfVector(titleTokens, docFreq, totalDocs);
      const descVec = this.buildTfIdfVector(descTokens, docFreq, totalDocs);

      const combinedVec = new Map<string, number>();
      titleVec.forEach((v, k) => combinedVec.set(k, (combinedVec.get(k) || 0) + v * 1.4));
      descVec.forEach((v, k) => combinedVec.set(k, (combinedVec.get(k) || 0) + v));

      let score = this.cosineSimilarity(qVec, combinedVec);

      const overlap = qTokens.filter(t => titleTokens.includes(t) || descTokens.includes(t));
      score += this.complianceBoost(overlap);

      const {penalty, missing} = this.missingConceptPenalty(qTokens, [...titleTokens, ...descTokens]);
      score *= (1 - penalty);

      if (item.description.toLowerCase().includes('incident response')) score += 0.06;

      if (score > bestScore) {
        bestScore = score;
        best = {
          ...item,
          confidence: Math.min(score, 0.99),
          debug: {penalty, missing, overlap}
        };
      }
    }

    if (!best || bestScore < 0.30) return null;
    return best;
  }


  downloadSurvey() {
    if (!this.uploadedSurveyFile) {
      this.alertService.warn('No survey uploaded to download.');
      return;
    }


    const reader = new FileReader();

    reader.onload = (e: any) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, {
          type: 'array',
          cellStyles: true,
          cellFormula: true,
          cellNF: true
        });

        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        // Build fast lookup: question text -> FormGroup
        const questionMap = new Map<string, FormGroup>();
        this.survey.questions.forEach(q => {
          if (q.matched && q.controlItemFG) {
            questionMap.set(q.text.trim(), q.controlItemFG);
          }
        });

        const range = XLSX.utils.decode_range(sheet['!ref']!);

        // Start after header row (adjust if needed)
        for (let r = range.s.r + 1; r <= range.e.r; r++) {
          const questionAddr = XLSX.utils.encode_cell({r, c: 4}); // Column D
          const answerAddr = XLSX.utils.encode_cell({r, c: 5}); // Column E

          const questionCell = sheet[questionAddr];
          if (!questionCell || typeof questionCell.v !== 'string') continue;

          const questionText = questionCell.v.trim();
          const fg = questionMap.get(questionText);
          if (!fg) continue;

          const response =
            fg.get('customResponse')?.value ||
            fg.get('response')?.value ||
            '';

          // Write value ONLY (preserves formatting)
          sheet[answerAddr] = {
            t: 's',
            v: response
          };
        }

        const wbout = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });

        const blob = new Blob([wbout], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = this.uploadedSurveyFile.name.replace(/\.xlsx$/i, '_filled.xlsx');
        a.click();
        URL.revokeObjectURL(url);

        console.log('Survey download complete.');
      } catch (err) {
        console.error('Error populating survey XLSX:', err);
        this.alertService.warn('Failed to download survey.');
      }
    };

    reader.readAsArrayBuffer(this.uploadedSurveyFile);
  }


  saveSurvey() {
    console.log('Saving populated survey:', this.survey);
    this.alertService.warn('Save functionality not implemented yet.');
  }

  removeSurveyQuestion(index: number) {
    this.survey.questions.splice(index, 1);
  }

  invite() {
    let config: MatDialogConfig = {
      width: "90%",
      height: "90%",
      data: {
        id: this.trustReport.id
      }
    };

    const ref = this.dialog.open(TrustBuilderInviteComponent, config);

    ref.afterClosed().subscribe((data: any) => {
      this.ngOnInit();
    });
  }

  public getFullName(user: User): string {
    if (user.firstName != null
      || user.lastName != null) {
      return user.firstName + ' ' + user.lastName;
    }

    return user.emailAddress;
  }

  sendInvite() {
    if (this.assignedUsers.length == 0) {
      this.alertService.success("Please, select users");
      return;
    }
    this.trustReportService.inviteToReport({
      ...this.trustReport,
      assignedUsers: this.assignedUsers
    }, this.inviteText).subscribe(() => {
      this.alertService.success("Invitations successfully sent");
    });
  }

  saveSettings() {
    this.clientProfileService.saveSettings(this.settings, LoginHelper.getTenantName()).subscribe(() => {
    });
  }

  public addLogo(event) {
    let attachments = event.target.files;
    if (attachments.length > 0) {
      this.trustReportService
        .uploadFile(attachments[0])
        .subscribe((data) => {
          this.settings.trustReportLogo = data.fileName;
          this.cdRef.detectChanges();
        });
    }
  }

  public addFile(event, field) {
    let attachments = event.target.files;
    if (attachments.length > 0) {
      this.trustReportService
        .uploadFile(attachments[0])
        .subscribe((data) => {
          this.trustReport[field] = data.fileName;
          this.cdRef.detectChanges();
        });
    }
  }

  selectDocumentFolder(field) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      height: '90%',
      data: {}
    };

    const dialogRef = this.dialog.open(DocumentFolderSelect, config);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.trustReport[field] = result;
        this.loadFiles(field.replace('Path', ''));
        this.cdRef.detectChanges();
      }
    });
  }

  loadAllFiles() {
    this.trustReport.policiesAndProceduresPath && this.loadFiles('policiesAndProcedures');
    this.trustReport.assessmentsAndAuthorizationsPath && this.loadFiles('assessmentsAndAuthorizations');
    this.trustReport.securityPlansPath && this.loadFiles('securityPlans');
  }

  loadFiles(field) {
    this.fileManagerBackendApiService.loadFilesWithPermanentTokens(this.trustReport[field + 'Path'], this.trustReport.id).subscribe(s => {
      this[field] = s;
      this[field].forEach(f => {
        f.extension = f.name.split('.').pop();
        f.rawName = f.name.replace(/^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})[_]?/, '');
        if (f.extension && f.extension !== f.rawName) {
          var name = f.rawName.length === (f.extension.length + 1) ? f.name : f.rawName;
          f.rawName = name.substring(0, name.length - f.extension.length - 1);
        }
      });
    });
  }


  protected readonly window = window;
}
